import styled from "@emotion/styled";

export const LinkHighlightArea = styled.div``;
